import { Box } from '@/components/Common/Box';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum } from '@/types/common';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const PaypalBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.PAYPAL}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.PAYPAL)}
    >
      <div className="flex flex-row items-center justify-center">
        <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.PAYPAL)} alt="paypal" />
      </div>
    </Box>
  );
};
